import { Outlet } from 'react-router-dom';
import { useAuth } from '@shadeables/supabase';
import LoggedInLayout from '../../components/LoggedInLayout';

const Layout = () => {
  const { user } = useAuth();

  if (user) {
    return <LoggedInLayout />;
  }

  return (
    <div>
      <main>
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
